/* This file was automatically generated */
export const classC24TapBarVisible = 'c24-tap-bar-visible';
export const classC24mPage = 'c24m-page';
export const classClearfix = 'clearfix';
export const classC24mCookieConsentWrapper = 'c24m-cookie-consent-wrapper';
export const classC24mCookieConsentNotice = 'c24m-cookie-consent-notice';
export const classC24mCookieConsentNoticeCnt = 'c24m-cookie-consent-notice-cnt';
export const classC24mCcLogo = 'c24m-cc-logo';
export const classC24mCookieConsentFunctional = 'c24m-cookie-consent-functional';
export const classC24mCookieConsentNoticeTitle = 'c24m-cookie-consent-notice-title';
export const classC24mCookieConsentNoticeButtons = 'c24m-cookie-consent-notice-buttons';
export const classC24mCookieConsentButton = 'c24m-cookie-consent-button';
export const classC24mCookieConsentButtonSecondary = 'c24m-cookie-consent-button-secondary';
export const classC24mCookieConsentImprint = 'c24m-cookie-consent-imprint';
export const classC24mCookieConsentImprintFlex = 'c24m-cookie-consent-imprint-flex';
export const classC24mCookieConsentScreen = 'c24m-cookie-consent-screen';
export const classC24mCookieConsentScreenCnt = 'c24m-cookie-consent-screen-cnt';
export const classC24mCookieConsentScreenTitle = 'c24m-cookie-consent-screen-title';
export const classC24mCookieConsentCookielink = 'c24m-cookie-consent-cookielink';
export const classC24mCookieConsentScreenList = 'c24m-cookie-consent-screen-list';
export const classC24mCookieConsentScreenListEntry = 'c24m-cookie-consent-screen-list-entry';
export const classC24mCookieConsentScreenListEntryHeader = 'c24m-cookie-consent-screen-list-entry-header';
export const classC24mCookieConsentButtonMoreIcon = 'c24m-cookie-consent-button-more-icon';
export const classC24mCookieConsentScreenListEntryContent = 'c24m-cookie-consent-screen-list-entry-content';
export const classC24mCookieConsentScreenListMTitle = 'c24m-cookie-consent-screen-list-m-title';
export const classC24mCookieConsentScreenListM = 'c24m-cookie-consent-screen-list-m';
export const classC24mCookieConsentScreenListMEntry = 'c24m-cookie-consent-screen-list-m-entry';
export const classC24mCookieConsentMToggle = 'c24m-cookie-consent-m-toggle';
export const classC24mCookieConsentScreenButtons = 'c24m-cookie-consent-screen-buttons';
export const classC24mSab = 'c24m-sab';
export const classC24mSabV2 = 'c24m-sab-v2';
export const classC24mSabClose = 'c24m-sab-close';
export const classC24mSabLogo = 'c24m-sab-logo';
export const classC24mSabText = 'c24m-sab-text';
export const classC24mSabTitle = 'c24m-sab-title';
export const classC24mSabStars = 'c24m-sab-stars';
export const classC24mSabReviewCount = 'c24m-sab-review-count';
export const classC24mButton = 'c24m-button';
export const classC24mSearchSlim = 'c24m-search-slim';
export const classC24mHeaderTopIconsLeft = 'c24m-header-top-icons-left';
export const classC24mHeaderBackWrapper = 'c24m-header-back-wrapper';
export const classC24mHeaderBack = 'c24m-header-back';
export const classC24mNavButton = 'c24m-nav-button';
export const classC24mHeaderIcon = 'c24m-header-icon';
export const classC24mNavButtonWrapper = 'c24m-nav-button-wrapper';
export const classC24mNavBurger = 'c24m-nav-burger';
export const classC24mNavSlideContent = 'c24m-nav-slide-content';
export const classC24mNavi = 'c24m-navi';
export const classC24mNaviHeader = 'c24m-navi-header';
export const classC24mNaviHeaderClose = 'c24m-navi-header-close';
export const classC24NavContentWrapper = 'c24-nav-content-wrapper';
export const classC24mNavComparisons = 'c24m-nav-comparisons';
export const classC24mNavCompBack = 'c24m-nav-comp-back';
export const classC24mNavCompItems = 'c24m-nav-comp-items';
export const classC24mNavCompItem = 'c24m-nav-comp-item';
export const classC24mNavVer = 'c24m-nav-ver';
export const classC24mNavCompItemSub = 'c24m-nav-comp-item-sub';
export const classC24mNavCompSubject = 'c24m-nav-comp-subject';
export const classC24mNavFin = 'c24m-nav-fin';
export const classC24mNavNrg = 'c24m-nav-nrg';
export const classC24mNavDsl = 'c24m-nav-dsl';
export const classC24mNavMof = 'c24m-nav-mof';
export const classC24mNavRsn = 'c24m-nav-rsn';
export const classC24mNavFlu = 'c24m-nav-flu';
export const classC24mNavHot = 'c24m-nav-hot';
export const classC24mNavMwa = 'c24m-nav-mwa';
export const classC24mNavTir = 'c24m-nav-tir';
export const classC24mNavLse = 'c24m-nav-lse';
export const classC24mNavTuh = 'c24m-nav-tuh';
export const classC24mNavSoc = 'c24m-nav-soc';
export const classC24mNavCnt = 'c24m-nav-cnt';
export const classC24mNaviElement = 'c24m-navi-element';
export const classC24NavSectionsWrapper = 'c24-nav-sections-wrapper';
export const classC24mNaviHeaderBottom = 'c24m-navi-header-bottom';
export const classC24UliloginlayerLoginOpener = 'c24-uliloginlayer-login-opener';
export const classC24mNaviSection = 'c24m-navi-section';
export const classC24mNaviSectionUser = 'c24m-navi-section-user';
export const classC24mNaviSvg = 'c24m-navi-svg';
export const classC24mUserLoggedin = 'c24m-user-loggedin';
export const classC24mUserLoggedout = 'c24m-user-loggedout';
export const classC24mNaviElementApp = 'c24m-navi-element-app';
export const classC24mNaviOpener = 'c24m-navi-opener';
export const classC24mNaviSectionBottom = 'c24m-navi-section-bottom';
export const classC24mNaviSectionLogout = 'c24m-navi-section-logout';
export const classC24mKbLogoutNavi = 'c24m-kb-logout-navi';
export const classC24mNaviLogout = 'c24m-navi-logout';
export const classC24mHeaderTopIconsRight = 'c24m-header-top-icons-right';
export const classC24mCustomer = 'c24m-customer';
export const classC24mCustomerGuest = 'c24m-customer-guest';
export const classC24mCustomerIcon = 'c24m-customer-icon';
export const classC24mCustomerIconLo = 'c24m-customer-icon-lo';
export const classC24mCustomerUser = 'c24m-customer-user';
export const classC24mCustomerIconLi = 'c24m-customer-icon-li';
export const classC24mCustomerExpired = 'c24m-customer-expired';
export const classC24mContactWrapper = 'c24m-contact-wrapper';
export const classC24mContactIcon = 'c24m-contact-icon';
export const classC24mContactLayer = 'c24m-contact-layer';
export const classC24mContactLayerCorner = 'c24m-contact-layer-corner';
export const classC24mContactLayerClose = 'c24m-contact-layer-close';
export const classC24mContactLayerContentWrapper = 'c24m-contact-layer-content-wrapper';
export const classC24mContactSlogan = 'c24m-contact-slogan';
export const classC24mContactLayerContent = 'c24m-contact-layer-content';
export const classC24mSearchIconWrapper = 'c24m-search-icon-wrapper';
export const classC24mSearchIcon = 'c24m-search-icon';
export const classC24mHeaderContent = 'c24m-header-content';
export const classC24mSearchContent = 'c24m-search-content';
export const classC24mInput = 'c24m-input';
export const classC24mSearchButton = 'c24m-search-button';
export const classC24mSearchClear = 'c24m-search-clear';
export const classC24mPageContent = 'c24m-page-content';
export const classC24mFooter = 'c24m-footer';
export const classC24mTapBar = 'c24m-tap-bar';
export const classC24mTapBarOption = 'c24m-tap-bar-option';
export const classC24mTapBarOptionStart = 'c24m-tap-bar-option-start';
export const classC24mTapBarIcon = 'c24m-tap-bar-icon';
export const classC24mTapBarText = 'c24m-tap-bar-text';
export const classC24mTapBarOptionActivity = 'c24m-tap-bar-option-activity';
export const classC24mTapBarOptionNewsfeed = 'c24m-tap-bar-option-newsfeed';
export const classC24mTapBarOptionOverview = 'c24m-tap-bar-option-overview';
export const classC24mTapBarOptionChat = 'c24m-tap-bar-option-chat';
export const classC24mFooterContent = 'c24m-footer-content';
export const classC24mFooterList = 'c24m-footer-list';
export const classC24FooterLinkContact = 'c24-footer-link-contact';
export const classC24FooterNavEle = 'c24-footer-nav-ele';
export const classC24FooterLinkConditions = 'c24-footer-link-conditions';
export const classC24FooterLinkPrivacy = 'c24-footer-link-privacy';
export const classC24FooterLinkImprint = 'c24-footer-link-imprint';
export const classC24mCopyright = 'c24m-copyright';
export const classC24mDesktopLink = 'c24m-desktop-link';
export const classHitsSuggestDirectlink = 'hits-suggest-directlink';
export const classHitsSuggestPhraselink = 'hits-suggest-phraselink';
export const classHitsSuggestDirectlinkSubtitle = 'hits-suggest-directlink-subtitle';
export const classHitsSuggestCategory = 'hits-suggest-category';
export const classHitsTakeoverArrow = 'hits-takeover-arrow';
export const idC24mHtml = 'c24m-html';
export const idC24mBody = 'c24m-body';
export const idC24mPage = 'c24m-page';
export const idC24mPageBlockingLayer = 'c24m-page-blocking-layer';
export const idC24mCookieCheckboxFunctional = 'c24m-cookie-checkbox-functional';
export const idC24mCookieConsentFunctionalMoreIcon = 'c24m-cookie-consent-functional-more-icon';
export const idC24mCookieFunctionalText = 'c24m-cookie-functional-text';
export const idC24mCookieCheckboxAnalytics = 'c24m-cookie-checkbox-analytics';
export const idC24mCookieConsentAnalyticsMoreIcon = 'c24m-cookie-consent-analytics-more-icon';
export const idC24mCookieAnalyticsText = 'c24m-cookie-analytics-text';
export const idC24mCookieCheckboxMarketing = 'c24m-cookie-checkbox-marketing';
export const idC24mCookieConsentMarketingMoreIcon = 'c24m-cookie-consent-marketing-more-icon';
export const idC24mCookieMarketingText = 'c24m-cookie-marketing-text';
export const idCheck24CookieMarketing1 = 'check24-cookie-marketing-1';
export const idC24mCookieConsentMarketing1MoreIcon = 'c24m-cookie-consent-marketing-1-more-icon';
export const idC24mCookieMarketing1Text = 'c24m-cookie-marketing-1-text';
export const idCheck24CookieMarketing2 = 'check24-cookie-marketing-2';
export const idC24mCookieConsentMarketing2MoreIcon = 'c24m-cookie-consent-marketing-2-more-icon';
export const idC24mCookieMarketing2Text = 'c24m-cookie-marketing-2-text';
export const idCheck24CookieMarketing3 = 'check24-cookie-marketing-3';
export const idC24mCookieConsentMarketing3MoreIcon = 'c24m-cookie-consent-marketing-3-more-icon';
export const idC24mCookieMarketing3Text = 'c24m-cookie-marketing-3-text';
export const idCheck24CookieMarketing4 = 'check24-cookie-marketing-4';
export const idC24mCookieConsentMarketing4MoreIcon = 'c24m-cookie-consent-marketing-4-more-icon';
export const idC24mCookieMarketing4Text = 'c24m-cookie-marketing-4-text';
export const idCheck24CookieMarketing5 = 'check24-cookie-marketing-5';
export const idC24mCookieConsentMarketing5MoreIcon = 'c24m-cookie-consent-marketing-5-more-icon';
export const idC24mCookieMarketing5Text = 'c24m-cookie-marketing-5-text';
export const idC24mPageStrictBlockingLayer = 'c24m-page-strict-blocking-layer';
export const idC24mSab = 'c24m-sab';
export const idC24mHeader = 'c24m-header';
export const idC24mHeaderBlockingLayer = 'c24m-header-blocking-layer';
export const idC24mHeaderTop = 'c24m-header-top';
export const idC24mNav = 'c24m-nav';
export const idC24mNavButton = 'c24m-nav-button';
export const idC24mNavSlide = 'c24m-nav-slide';
export const idC24mNaviSalutationGuest = 'c24m-navi-salutation-guest';
export const idC24mKbLoginNavi = 'c24m-kb-login-navi';
export const idC24mNaviSalutationUser = 'c24m-navi-salutation-user';
export const idC24mNaviSalutationExpired = 'c24m-navi-salutation-expired';
export const idC24mNaviCustomer = 'c24m-navi-customer';
export const idC24mNaviCustomerUser = 'c24m-navi-customer-user';
export const idC24mNaviCustomerGuest = 'c24m-navi-customer-guest';
export const idC24mNaviCustomerExpired = 'c24m-navi-customer-expired';
export const idC24mKbLogoutNaviUser = 'c24m-kb-logout-navi-user';
export const idC24mKbLogoutNaviExpired = 'c24m-kb-logout-navi-expired';
export const idC24mLogo = 'c24m-logo';
export const idChattyChatbotLayer = 'chatty-chatbot-layer';
export const idC24HeaderBottom = 'c24-header-bottom';
export const idC24mSearch = 'c24m-search';
export const idC24mSearchForm = 'c24m-search-form';
export const idC24mSearchcontainer = 'c24m-searchcontainer';
export const idC24mSitesearchSuggester = 'c24m-sitesearch-suggester';
export const idSource_suggest = 'source_suggest';